import React, { useEffect } from 'react';

import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

// pages
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetails from './pages/ProductDetails';
import Search from './pages/Search';
import Order from "./pages/Order";

// components
import Header from './components/Header';
import Footer from './components/Footer';

//analytics
import { logEvent } from 'firebase/analytics';
import { analytics } from "./firebase";
import ScrollToTop from './components/ScrollToTop';


// layout
const Layout = () => {
    useEffect(() => {
        logEvent(analytics, 'button_click', {
            button_name: 'example_button'
        });
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <ScrollToTop />
            <Header />
            <main className="flex-grow">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

const router = createBrowserRouter([
    {
        element: <Layout />,
        children: [
            { path: '/', element: <Home /> },
            { path: '/products/:id', element: <Products /> },
            { path: '/product/:name', element: <ProductDetails /> },
            { path: '/order', element: <Order /> },
            { path: '/search', element: <Search /> },
        ],
    },
]);

const App = () => {
    return (
        <div>
            <RouterProvider router={router} />
        </div>
    );
};

export default App;
